import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
  description?: string | null
}

const Item = ({ title, description }: Props) => {
  const hasDescription = !!description

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
      <Text size="200" weight="normal" color="grey800">
        {title}
      </Text>
      {hasDescription ? (
        <Text size="300" weight="medium" color="grey1000" capitalize>
          {description}
        </Text>
      ) : (
        <Text size="300" weight="medium" color="grey600">
          {i18n.t('contract_versions.legal_and_labour.not_informed')}
        </Text>
      )}
    </Box>
  )
}

export default Item
